import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getById, getCall } from "../../utils/api";
import { GET_ALL_CRAWL_DATA } from "../../constant/api";

const initialState = {
  data: [],
  outletDetail: null,
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getAllCrawlData = createAsyncThunk(
  "CrawlAllData/getAllCrawlData",
  async () => {
    try {
      const response = await getCall(`${GET_ALL_CRAWL_DATA}?per_page=50&page=1`, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getCrawlDataById = createAsyncThunk(
  "CrawlAllData/getCrawlDataById",
  async (id) => {
    try {
      return await getById(`/admin/v1/crawl_data`, id, false);
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

const CrawlAllDataSlice = createSlice({
  name: "crawlAllData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllCrawlData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getAllCrawlData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getAllCrawlData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getCrawlDataById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getCrawlDataById.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(getCrawlDataById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
  },
});

export default CrawlAllDataSlice.reducer;
